<template>
    <div class="row">
		<loader v-if="pageLoader"></loader>
        <alert-notification v-if="notification_msg != ''"/>
        <div class="col-12 col-md-12 acountStatus">
            <div class="whiteBG supportpagetab radius mb-3">
                <!--<div class="d-flex justify-content-between border-bottom pb-3 px-3 mb-2">
                    <div></div>
                    <filter-component></filter-component>
                </div>
                <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>-->
                <div class="mapIco-list-table mt-4">
                    <div class="tablePmmu">
                        <table class="table pmmTable table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>ticket Number</th>
                                    <th>reason</th>
                                    <th>created</th>
                                    <th>action</th>
                                </tr>
                            </thead>
                            <tbody v-if="(!pageLoader && ticketList != '' && ticketList.totalRecords > 0)">
                                <tr v-for="list in ticketList.records">
                                    <td>{{list.ticket}}</td>
                                    <td>
                                        <span v-if="list.reason && parseInt(list.reason) == 91">Document Verification</span>
                                        <span v-else-if="ticketReasonList[list.reason] && ticketReasonList[list.reason].categories && parseInt(list.title) != 0">
                                            <label v-for="catlist in ticketReasonList[list.reason].categories" v-if="catlist.id == list.title"> {{catlist.title}}</label>
                                        </span>
                                        <span v-else-if="ticketReasonList[list.reason]">
                                            {{ticketReasonList[list.reason].title}}
                                        </span>
                                        <span v-else>-</span>
                                    </td>
                                    <td>{{list.created | moment("dddd DD MMMM, YYYY")}}</td>
                                    <td> 
    				                	<span class="vierIcon"><router-link :to="{name: 'view' , query: { 'id':list.id}}" class="prism_btn width_xs btn_xs green_btn" title="View" data-placement="top"  data-toggle="tooltip">
                                            <feather type="eye"></feather>
                                        </router-link></span>
    				               	</td>
                                </tr>
                            </tbody>
                            <table-loader :pageloader_value="pageLoader" :type="'table'" :colspan="'4'" :listLength="ticketList.totalRecords" v-else></table-loader>
                        </table>
                        
                    </div>
                </div> 
            </div>
            <pagination :totalRecords="ticketList.totalRecords" :limit="pageLimit" v-if="ticketList.totalRecords > 0" :pageNo="page"></pagination>
        </div>
    </div>
     
</template>
<script> 
    import { supportMixins } from '@/plugins/support'
	export default {
		name: 'OPEN-TICKET',
        mixins: [supportMixins],
		data () {
			return {
                //===========prop in loader component=======
                col_span : 4,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                notification_msg:'',
                notification_type:'',
                loaderFuncRun : '1',
                //==========================================
				page : '1',
                search : '',
                pageLimit : '15'
			}
		},
        props:['pageLim'],
		methods:{
            listing(){
                let input_json={
                    'globalParams' :{
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                        'status' : this.$parent.ticket_status
                    },
                    'localParams' :{ "parameter" : this ,'loaderFuncRun' : this.loaderFuncRun}
                }
                this._runGetTicketList(input_json)
            }
		},
		created(){
			this.listing()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/supports/support.vue